import { render, staticRenderFns } from "./ChangeEmail.vue?vue&type=template&id=205b33ed&scoped=true&"
import script from "./ChangeEmail.vue?vue&type=script&lang=js&"
export * from "./ChangeEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205b33ed",
  null
  
)

export default component.exports